export class ArrayHelper {
  static containsAll(needles: string[], haystack: string[]): boolean {
    return needles.every((needle) => haystack.includes(needle));
  }
}
